import Map, { Marker } from 'react-map-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Coordinates } from './MapViewModal';

const MAPBOX_TOKEN =
  import.meta.env.VITE_MAPBOX_TOKEN ||
  'pk.eyJ1IjoidmlydHVhbGh1YmRvYTIwMjUiLCJhIjoiY205djB0bHVlMGV6MDJycHJlZXZqdnQ3MiJ9.Rkk5tZJDQQzrDIoQEpLjgw';

export type Props = {
  coordinates: Coordinates;
};

const MapBox = ({ coordinates }: Props) => {
  console.log('GETTING HERE', coordinates);
  return (
    <div className="w-full h-[500px]">
      <Map
        mapboxAccessToken={MAPBOX_TOKEN}
        initialViewState={{
          longitude: 122.5621,
          latitude: 10.7202,
          zoom: 12,
        }}
        mapStyle="mapbox://styles/mapbox/streets-v11"
        style={{ width: '100%', height: '100%' }}
      >
        {coordinates?.latitude && coordinates?.longitude && (
          <Marker
            longitude={Number(coordinates.longitude)}
            latitude={Number(coordinates.latitude)}
          />
        )}
      </Map>
    </div>
  );
};

export default MapBox;
